import { Link } from "react-router-dom";
import { Check, Clock } from "lucide-react";

export default function ServiceCard({ service }) {
  const { id, name, duration, price, blurb, bestFor, benefits, featured } = service;
  return (
    <article
      data-testid={`service-card-${id}`}
      className={`relative cc-card p-8 md:p-10 flex flex-col h-full transition-transform duration-500 hover:-translate-y-1 ${
        featured ? "ring-1 ring-[var(--cc-primary)]/30 bg-[var(--cc-surface-2)]" : ""
      }`}
    >
      {featured && (
        <span
          data-testid={`service-badge-${id}`}
          className="absolute -top-3 left-8 px-3 py-1 rounded-full bg-[var(--cc-primary)] text-white text-[10px] uppercase tracking-[0.18em]"
        >
          Most chosen
        </span>
      )}

      <div className="flex items-center justify-between">
        <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-[var(--cc-text-soft)]">
          <Clock size={13} strokeWidth={1.5} className="text-[var(--cc-primary)]" />
          {duration}
        </span>
        <span className="font-serif text-3xl text-[var(--cc-text)]">{price}</span>
      </div>

      <h3 className="mt-6 font-serif text-2xl md:text-[1.7rem] leading-snug">
        {name}
      </h3>

      <p className="mt-4 text-[var(--cc-text-soft)] leading-relaxed">{blurb}</p>

      <div className="mt-6 pt-6 border-t border-[var(--cc-line)]">
        <p className="text-xs uppercase tracking-[0.18em] text-[var(--cc-text-soft)] mb-3">
          Best for
        </p>
        <p className="text-[var(--cc-text)]">{bestFor}</p>
      </div>

      <ul className="mt-6 space-y-2.5">
        {benefits.map((b) => (
          <li key={b} className="flex items-start gap-2.5 text-sm text-[var(--cc-text-soft)]">
            <Check size={15} strokeWidth={1.8} className="mt-1 text-[var(--cc-primary)] shrink-0" />
            <span>{b}</span>
          </li>
        ))}
      </ul>

      <div className="mt-8 pt-2">
        <Link
          to="/booking"
          data-testid={`service-cta-${id}`}
          className="cc-btn-secondary w-full justify-center"
        >
          Schedule a Conversation
        </Link>
      </div>
    </article>
  );
}
